module.exports = __webpack_public_path__ + "img/icon-blogger.57925fa9.svg";